export default __webpack_public_path__ + "static/media/shield-logo.1aeb5d8f.png";